<template>
    <div>
        <div class="tab-container card">
            <swb-query-sort-area :config="queryConfig" :queryKey="queryKey" :queryHandler="queryHandler"></swb-query-sort-area>
            <div class="table-layout">
                <el-table ref="multipleTable" :data="servicerEngineerList" border tooltip-effect="dark" style="width: 100%" @current-change="handleCurrentChange" @selection-change="handleSelectionChange">
                    <el-table-column align="center" type="selection" width="55" v-if="!isRadio"></el-table-column>
                    <el-table-column width="55" fixed="left" v-if="isRadio">
                        <template slot-scope="rows">
                            <div class="copy-radio ml15" :class="{'circle' : selectEngineer!= null && selectEngineer.id == rows.row.id}">
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="name" label="工程师名称">
                        <template slot-scope="rows">
                            <span>{{rows.row.name}}&nbsp;&nbsp;</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="servicerStaff.osFlag" label="是否外协" width="80" align="center">
                        <template slot-scope="rows">
                            <span v-if="!rows.row.servicerStaff.osFlag">否</span>
                            <span v-else="rows.row.servicerStaff.osFlag">是</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="lastFlag" label="是否最近" width="80" align="center">
                        <template slot-scope="rows">
                            <span v-if="rows.row.lastFlag">是</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="deftFlag" label="是否默认" width="80" align="center">
                        <template slot-scope="rows">
                            <span v-if="rows.row.deftFlag">是</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="serveNo" label="服务工号" width="100"></el-table-column>
                    <el-table-column prop="contactTel" label="联系电话" width="150"></el-table-column>
                </el-table>
            </div>
        </div>
    </div>
</template>

<script>
    import { Utils } from '../../app.base'
    import { Vue, MsgBox } from '../../app.vues'

    import { openStaffQualiForSelectDlg } from '../quali/selectDlg';

    import servicerApi from '../../api/servicer'

    let searchConfigData = {
        "queryFields": [
            {
                "type": "Text",
                "label": "工程师名称",
                "code": "name",
                "basic": true,
                "valueType": "String"
            }
        ],
        "sortFields": []
    };

    export default {
        name: 'swb-servicer-engineer-list-for-select',
        desc: '服务工程师-选择',
        props: {
            servicerShopId: {
                type: Number,
                default: null
            },
            merchantId: {
                type: Number,
                default: null
            },
            isRadio: {
                type: Boolean,
                default: false
            },
        },
        data: function () {
            return {
                name: null,
                servicerEngineerList: [],
                selectEngineer: null,
                selectEngineerList: [],
                flag: 0,
                workState: [],
                //排序、搜索
                queryConfig: null,
                queryKey: null,
                AuditPass: null,
                queryModel: {
                    filterItems: {},
                    sortItemList: [],
                    sortItems: {},
                },
                ssuId: null
            }
        },
        created: function () {
            if(this.onlyShowAll) {
                this.flag = 2;
            }
            if(this.ssuIdList != null && this.ssuIdList > 0) {
                this.ssuId = this.ssuIdList[0];
            }
            this.queryConfig = searchConfigData || {};
            this.workState = getEnumMap('workState', 'value2text');
            // 全部符合的工程师列表
            this.getServicerEngineerList();
        },
        methods: {
            queryHandler(queryModel) {
                //1、接收查询条件
                this.queryModel = queryModel;
                //缓存查询条件
                this.getServicerEngineerList();
            },
            isActiveFlag(flag){
                return this.flag == flag;
            },
            setActiveFlag(flag) {
                this.flag = flag;
                this.getServicerEngineerList();
            },

            viewStaffQuali(row){
                console.log(row);
                let merchantType = 4;// 服务商
                let filter = {
                    merchantId: row.merchantId,
                    staffId: row.id,
                    forEngineer: true,
                    checkFlag: 1 // 0:：未核对，1：核对有效，-1：核对无效
                };
                openStaffQualiForSelectDlg(merchantType, filter);
            },
            //初始化
            getServicerEngineerList: function () {
                let self = this;
                let postData = {};
                //
                let queryModel = self.queryModel;
                let filterItems = Utils.merge({}, queryModel.filterItems);
                let sortItemList = Utils.merge([], queryModel.sortItemList);
                let sortItems = Utils.merge({}, queryModel.sortItems);

                filterItems.merchantId = self.merchantId;
                if(!Utils.isNoB(self.servicerShopId)) {
                    filterItems.comId = self.servicerShopId;
                }
                filterItems.deleted = false;
                postData.filterItems = filterItems;
                postData.sortItemList = sortItemList;
                postData.sortItems = sortItems;
                //
                let theLoading = MsgBox.loading();
                servicerApi.getServicerEngineerListForSelected(postData, function (result) {
                    theLoading.close();
                    if(result.type === "info") {
                        let servicerEngineerList = result.data;
                        self.servicerEngineerList = servicerEngineerList;
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },

            handleSelectionChange: function (val) {
                this.selectEngineerList = val;
            },
            handleCurrentChange: function (val) {
                this.selectEngineer = Utils.merge({}, val);
            },
            getDlgResult: function () {
                let self = this;
                let result = {};
                if(this.isRadio) {
                    if(this.selectEngineer != null) {
                        result.type = "info";
                        result.data = this.selectEngineer;
                    } else {
                        result.type = "warn";
                        result.message = "请选择工程师";
                    }
                    return result;
                }

                let selectEngineerList = self.selectEngineerList;
                if(selectEngineerList != null && selectEngineerList.length > 0) {
                    if(!self.isActiveFlag(0)) {
                        result.type = "info";
                        result.data = selectEngineerList;
                        for(let i = 0; i < selectEngineerList.length; i++) {
                            let engineer = selectEngineerList[i];
                            if(engineer.servicerStaff != null) {
                                let servicerStaff = engineer.servicerStaff;
                                if(servicerStaff.disabled) {
                                    result.type = "warn";
                                    result.message = "工程师【" + servicerStaff.name + "】已被禁用，请重新选择";
                                    return result;
                                }
                            }
                        }
                    }
                    result.type = "info";
                    result.data = selectEngineerList;
                } else {
                    result.type = "warn";
                    result.message = "请选择工程师";
                }
                return result;
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/servicer/ServicerEngineerListForSelect.vue